<template>
    <el-card shadow="never" class="aui-card--fill">
        <div class="mod-plat__platdealapproval}">
            <el-table  :data="tableData" >
                <!--  <el-table-column prop="id" label="id" header-align="center" align="center"></el-table-column>-->
                <el-table-column prop="serialNumber" label="交易编号" header-align="center" align="center"></el-table-column>
                <el-table-column prop="payerAccountTitle" label="支付方账户名称" header-align="center" align="center"></el-table-column>
                <el-table-column prop="payerBankAccount" label="支付方银行账号" header-align="center" align="center"></el-table-column>
                <el-table-column prop="createDate" label="业务日期" header-align="center" align="center"></el-table-column>
                <el-table-column prop="businessType" label="业务类型" header-align="center" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.businessType === 'cz'">充值</span>
                        <span v-else-if="scope.row.businessType === 'grsk'">个人收款</span>
                        <span v-else>支付</span>
                    </template>
                </el-table-column>
                <el-table-column prop="payeeBankName" label="收款方账户名称" header-align="center" align="center"></el-table-column>
                <el-table-column prop="payeeBankAccount" label="收款方银行账号" header-align="center" align="center"></el-table-column>
                <el-table-column prop="amount" label="结算金额(元)" header-align="center" align="center"></el-table-column>
                <el-table-column prop="contractCode" label="关联合同编号" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-button style="word-break: break-all;white-space: wrap;" type="text" size="small" @click="infoHandle(scope.row.contractId)">{{scope.row.contractCode}}</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="summary" label="关联任务编号" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-button style="word-break: break-all;white-space: wrap;" type="text" size="small" @click="taskinfoHandle(scope.row.taskId)">{{scope.row.taskCode}}</el-button>
                    </template>
                </el-table-column>

            </el-table>
            <el-pagination
                    background
                    :current-page="pageObject.page"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageObject.limit"
                    :total="pageObject.total"
                    layout="total, sizes, prev, pager, next, jumper"
                    @size-change="handlePageSize"
                    @current-change="handleCurrentPage">
            ></el-pagination>
        </div>
    </el-card>
</template>
<script>
    import { addDynamicRoute } from '@/router';

    export default {
        name:'personal-settlement',
        data() {
            return {
                settlement:'1',
                settlementList: [
                    {
                        value: '0',
                        label: '企业结算列表'
                    },
                    {
                        value: '1',
                        label: '个人结算列表'}
                ],
                tableData:[],
//                分页器参数
                pageObject:{
                    page : 1,
                    limit : 10,
                    total : 0,
                 },
            }
        },
        prop: {},
        components: {

        },
        watch: {},
        computed: {
        },
        methods: {
//            用户结算状态事件
            handleStatusChange(e){
                if(e == 0){

                    const routeParams = {
                        routeName: `plat-batch-settlement-list`,
                        title: "",
                        path: 'plat/batch-settlement-list'
                    }
                    // 动态路由
                    addDynamicRoute(routeParams, this.$router)
                }
            },

            handleQuery(){
                this.$http.get(`/sys/plat/deal/approval/getPersonalStatementList?page=${this.pageObject.page}&limit=${this.pageObject.limit}`).then(({data:res})=>{
                    if(res.code == 0){
                        this.tableData = res.data.list
                    }
                })
            },
//任务发布编号
            goTaskInfo(id){
                // 路由参数
                const routeParams = {
                    routeName: `${this.$route.name}__任务详情`,
                    title: `任务详情`,
                    path: 'plat/platttask-info',
                    params: {
                        id:id
                    }
                }
                // 动态路由
                addDynamicRoute(routeParams, this.$router)
            },
            taskinfoHandle(id) {
                const routeParams = {
                    routeName: `${this.$route.name}__任务详情`,
                    title: `任务详情`,
                    path: 'plat/platttask-info',
                    params: {
                        id:id
                    }
                }
                // 动态路由
                addDynamicRoute(routeParams, this.$router)
            },
// 合同编号
            infoHandle(id) {
                // 路由参数
                const routeParams = {
                    routeName: `${this.$route.name}__合同详情`,
                    title: `合同详情`,
                    path: 'plat/platcontract-info',
                    params: {
                        id:id
                    }
                }
                // 动态路由
                addDynamicRoute(routeParams, this.$router)
            },
            //分页
            handlePageSize(val){
                this.pageObject.page = 1
                this.pageObject.limit = val
                this.handleQuery()
            },
//当前页数
            handleCurrentPage(val){
                this.pageObject.page = val
                this.handleQuery()
            },

        },
        created(){
                this.handleQuery()
        }
    }
</script>
<style lang="scss">
</style>